import {Line} from './Line';

declare const THREE: any;

export class Border extends (THREE.Object3D as { new(): any; }) {

  constructor(points: Array<any>) {
    super();
    for (let i = 0; i < points.length; i++) {
      const firstPoint = points[i];
      const secondPoint = points[(i + 1) % points.length];
      this.add(new Line(
        new THREE.Vector3(firstPoint.x, 0, firstPoint.y),
        new THREE.Vector3(secondPoint.x, 0, secondPoint.y))
      );
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/services/proTools/object3D/Floor/border.ts